import BaseService from "./geral/BaseService";

const base = "SolicitacaoDesovaPier";

class DesovaPierService extends BaseService {
    constructor() {
        super(base);
    }

    obterOperacoes(){
        return super.httpGet(`/${base}/listar-operacoes`);
    }

    carregarPorNcm(documento){
        return super.httpGet(`/${base}/obter-ce?numeroBl=${documento}`);
    }

    carregarPorCnpj(cnpj){
        return super.httpGet(`/${base}/buscar-empresa?cnpj=${cnpj}`);
    }

    async filtrarSolicitacoes({ filterSolicitante, operacao, container, tipo, bl, dataInicial, dataFinal }){
        try {
            const response = await super.httpGet(`${base}/listar?filterSolicitante=${filterSolicitante ? 'S' : ''}&operacao=${operacao}&conteiner=${container}&situacao=${tipo}&bl=${bl}&dataInicial=${dataInicial}&dataFinal=${dataFinal}`)
            const { data: { Data } } = response;
            const resultadoPesquisa = []
            for (const element of Data) {
                const index = resultadoPesquisa.findIndex(i => i.Id === element.Id)
                if (index === -1) {
                    resultadoPesquisa.push(element);
                } else {
                    resultadoPesquisa[index].Container += `/${element.Container}`
                }

            }
            console.log({resultadoPesquisa})
            return resultadoPesquisa
        } catch (error) {
            console.error(error);
            return null 
        }
    }

    obterSolicitacao(id){
        return super.httpGet(`${base}/obter?idDesova=${id}`);
    }

    inativarSolicitacao(id){
        return super.httpDelete(`${base}/excluir?id=${id}`);
    }

    persistirSolicitacao = (solicitacao) =>
    {
        return super.httpPost(`${base}/salvar`, solicitacao);
    }

    salvarAnexo(arquivo, extensao, nome, idDesova, idDocumento){
        return super.httpPost(`${base}/anexar?DesovaId=${idDesova || 0}&DocumentoId=${idDocumento || 0}&Extensao=${extensao}&NomeArquivo=${nome}`, arquivo);
    }

    downloadAnexo = (id) =>{
        return super.httpGet(`${base}/baixar-arquivo?idArquivo=${id}`);
    }

    deletarAnexo = (id) => {
        return super.httpDelete(`${base}/excluir-arquivo?id=${id}`);
    }

    deletarContainer = (id) => {
        return super.httpDelete(`${base}/remover-conteiner?conteinerId=${id}`);
    }

    obterAnexosDesovaPorDocId = (id) => {
        return super.httpGet(`${base}/obter-anexos?DocumentoId=${id}`);
    }
}

export default new DesovaPierService();


// WEBPACK FOOTER //
// ./src/services/DesovaPierService.js